import { render, staticRenderFns } from "./TableInscribir.vue?vue&type=template&id=6a223ea5&scoped=true"
import script from "./TableInscribir.vue?vue&type=script&lang=js"
export * from "./TableInscribir.vue?vue&type=script&lang=js"
import style0 from "./TableInscribir.vue?vue&type=style&index=0&id=6a223ea5&prod&scoped=true&lang=css"
import style1 from "./TableInscribir.vue?vue&type=style&index=1&id=6a223ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a223ea5",
  null
  
)

export default component.exports